import React, { useContext, useEffect, useState } from "react";
import API from "../../../../Functions/API/api";
import "./ReportsLayout.css";
import { AuthContext } from "../../../../context/authContext";
import { renderStatementWithKaTeX } from "../../../../Functions/WriteLaTex";

function ReportsList() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const {user}=useContext(AuthContext)

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      const res = await API.get("/reports/unresolved");
      setReports(res.data);
    } catch (err) {
      console.error("Error fetching reports:", err);
    } finally {
      setLoading(false);
    }
  };

  const markAsSolved = async (id) => {
    try {
      await API.patch(`/reports/${id}/solve`,{Solvername:user?.username,Solver_id:user?._id});
      setReports(reports.filter((r) => r._id !== id)); // remove solved one
    } catch (err) {
      console.error("Error updating report:", err);
    }
  };

  if (loading) return <p>Loading reports...</p>;

  return (
    <div className="reports-container">
        <div className="Intro">
        <h1>🚩 Reports Management :</h1>
        <p>
          <b>Instructions : </b>
          Welcome to the Report Management dashboard. Here, you can view all unresolved issue reports submitted by users. Each report displays the author, subject, detailed explanation, and submission time. You can quickly mark issues as solved using the tick button, keeping track of progress and ensuring timely resolution of user-reported problems.
        </p>
      </div>
      <h2>Unresolved Reports</h2>
      {reports.length === 0 ? (
        <p className="no-reports">No unresolved reports 🎉</p>
      ) : (
        <div className="reports-list">
          {reports.map((r) => (
            <div className="report-card" key={r._id}>
              <button
                className="btn-solve-circle"
                onClick={() => markAsSolved(r._id)}
                title="Mark as Solved"
              >
                ✓
              </button>
              <div className="report-header">
                <h3>{r.subject}</h3>
                <span className="report-author">By {r.author?.name}</span>
              </div>
              <div className="report-explanation">
                {renderStatementWithKaTeX(r.explanation)}
              </div>
              <div className="report-footer">
                <span>{new Date(r.createdAt).toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ReportsList;
